import 'react';
import {Badge, Box} from '@mui/material';
import {MoneyField} from '@/components/common/MoneyField';
import type {AdjustmentDetail} from '@/services/auditService/interface/wp-row';

type Props = {
    value: number | string | null | undefined;
    currencySymbol?: string;
    adjustments?: AdjustmentDetail[] | null;
    itemLabel: string;
    onOpenDetails: (headerIds: string[], name: string) => void;
};

/**
 * Loan amount display: when field adjustments exist, show count badge (top-right)
 * and open AdjustmentDetailsDrawer on click.
 */
export default function LoanAdjAmountBadge({
    value,
    currencySymbol,
    adjustments,
    itemLabel,
    onOpenDetails,
}: Props) {
    const list = Array.isArray(adjustments) && adjustments.length > 0 ? adjustments : null;

    const money = (
        <MoneyField
            value={value}
            currencySymbol={currencySymbol}
            showCents={true}
            align="center"
            compact={true}
        />
    );

    if (!list) return money;

    return (
        <Box
            sx={{
                cursor: 'pointer',
                borderRadius: 0.5,
                '&:hover': {backgroundColor: 'action.hover'},
            }}
            onClick={() => {
                const ids = list.map((a) => a.adjustHeaderId).filter((id): id is string => typeof id === 'string' && !!id);
                if (ids.length > 0) onOpenDetails(ids, itemLabel);
            }}
            title="View adjustment details"
        >
            <Badge
                badgeContent={list.length}
                color="primary"
                sx={{'& .MuiBadge-badge': {fontSize: 10, height: 16, minWidth: 16}}}
            >
                {money}
            </Badge>
        </Box>
    );
}
